import { Link } from "react-router-dom";
import type { CartItem } from "@/types";
import { formatBRL } from "@/lib/format";
import QuantityStepper from "@/components/base/QuantityStepper";

interface CartItemRowProps {
  item: CartItem;
  onChangeQuantity: (key: string, quantity: number) => void;
  onRemove: (key: string) => void;
  onNavigate?: () => void;
}

export default function CartItemRow({
  item,
  onChangeQuantity,
  onRemove,
  onNavigate,
}: CartItemRowProps) {
  return (
    <article className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3">
      <Link
        to={`/produto/${item.productId}`}
        onClick={onNavigate}
        className="h-24 w-20 shrink-0 cursor-pointer overflow-hidden rounded-md bg-background-200"
      >
        <img
          src={item.image}
          alt={`${item.name} na cor ${item.colorName}`}
          title={`${item.name} — Auréa`}
          className="h-full w-full object-cover object-top"
        />
      </Link>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <Link
              to={`/produto/${item.productId}`}
              onClick={onNavigate}
              className="cursor-pointer font-heading text-lg leading-snug text-foreground-900 transition-colors hover:text-primary-600"
            >
              {item.name}
            </Link>
            <p className="mt-0.5 text-[11px] uppercase tracking-[0.12em] text-foreground-500">
              {item.code}
            </p>
          </div>
          <button
            type="button"
            onClick={() => onRemove(item.key)}
            aria-label={`Remover ${item.name} da sacola`}
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-500 transition-colors hover:bg-accent-50 hover:text-accent-700"
          >
            <i className="ri-delete-bin-6-line text-base" />
          </button>
        </div>

        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-600">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <span
              className="h-3.5 w-3.5 rounded-full border border-background-300"
              style={{ backgroundColor: item.colorHex }}
            />
            {item.colorName}
          </span>
          <span className="whitespace-nowrap">{/^\d+$/.test(item.size) ? `Numeração ${item.size}` : `Tamanho ${item.size}`}</span>
        </div>

        <div className="mt-3 flex items-end justify-between gap-3">
          <QuantityStepper
            value={item.quantity}
            max={item.stock || 99}
            onChange={(value) => onChangeQuantity(item.key, value)}
            size="sm"
          />
          <div className="text-right">
            <p className="text-sm font-medium text-primary-700">
              {formatBRL(item.unitPrice * item.quantity)}
            </p>
            <p className="text-[11px] text-foreground-500">{formatBRL(item.unitPrice)} cada</p>
          </div>
        </div>
      </div>
    </article>
  );
}